export default "__VITE_ASSET__Ds00eG1W__"